import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { createStructuredSelector } from 'reselect';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { getClassNames } from './index.classNames';
import { DocumentActions as UiDocumentActions} from '../../../redux/actions/ui';
import { CommandActions as DocumentCommandActions} from '../../../redux/actions/document';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import { CommandActions as ModalCommandActions} from '../../../redux/actions/modal';
import _ from 'lodash'
import { getFilterPanelOpened } from '../../../redux/reducers/ui';
import { Document, getChangeStatusEmptyFileForm, getEmptyCommentFileForm, getEmptyFileForm } from '../../../models/document';
import { getTotal } from '../../../redux/reducers/documents';
import { getStatusValues } from '../../../redux/reducers/sharedData';
import { Status } from '../../../models/status';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { getSelectedProject, getSelectedProjectCodeword } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { getContextualDocuments, getSelectedDocument } from '../../../redux/selectors/documents';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { formatDateFile } from '../../../utils/functions';

export interface ContactsProps extends WithTranslation {
    filterPanelOpened: boolean, 
    documents: Document[],
    total: number,
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    statusValues: Status[],
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    selectedProject?: Project,
    selectedDocument?: Document,
    codeWord?: string,
    setFilterPanelOpened: typeof UiDocumentActions.setFilterPanelOpened,
    openEditModal: typeof DocumentsCommandActions.openEditModal,
    setOpenModal: typeof DocumentCommandActions.setOpenModal,
    openGenericModal: typeof ModalCommandActions.openModal,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadFiles: typeof DocumentsCommandActions.downloadFiles,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
}

class DocumentsCommandBar extends React.Component<ContactsProps> {
    constructor(props: ContactsProps) {
        super(props);
    }   

    getButtons = () => {
        const { documents, selectedDocument, total, selectedProject, openGenericModal, fetchDocuments, loadingContent, loading, loadingScroll, statusValues, userProjectActions, codeWord, t } = this.props;
        let buttons: ICommandBarItemProps[] = [];
        let selectedDocumentIds = _.map(documents, d => d.id as number);
        let approveStatus = _.find(statusValues, a => a.name === 'approved') as Status;
        let approveCommentsStatus = _.find(statusValues, a => a.name === 'approved-comments') as Status;
        let rejectedStatus = _.find(statusValues, a => a.name === 'rejected') as Status;
        const commentsExist = (documents && documents.length > 0) ? _.some(documents, d => d.comments && d.comments.length > 0) : true;

        buttons = [   
            ...(_.find(userProjectActions, a => a === 'ApprovePending') ? [{ //isExternalApp
                key: 'approve',
                name: t('Approve'),
                disabled: (selectedDocumentIds.length === 0 || (_.some(documents, (d: Document) => !d.isCurrent)) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...approveStatus}, fileForm: getChangeStatusEmptyFileForm()}})},
                iconProps: {
                    iconName: (approveStatus) ? approveStatus.icon : undefined,
                    style: {color: (approveStatus) ? approveStatus.color : undefined} 
                }
            }] : []),       
            ...(( _.find(userProjectActions, a => a === 'ApprovePending')) ? [{ //isExternalApp
                key: 'approveComments',
                name: t('Approve with comments'),
                disabled: (selectedDocumentIds.length === 0 || (_.some(documents, (d: Document) => !d.isCurrent)) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...approveCommentsStatus}, fileForm: getEmptyCommentFileForm(), files: []}, optional: true})},
                iconProps: {
                    iconName: (approveCommentsStatus) ? approveCommentsStatus.icon : undefined,
                    style: {color: (approveCommentsStatus) ? approveCommentsStatus.color : undefined} 
                }
            }] : []),  
            ...((_.find(userProjectActions, a => a === 'DeclinePending')) ? [{ //isExternalApp
                key: 'decline',
                name: t('Reject'),
                disabled: (selectedDocumentIds.length === 0 || (_.some(documents, (d: Document) => !d.isCurrent)) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...rejectedStatus}, fileForm: getEmptyCommentFileForm(), files: []}, optional: true})},
                iconProps: {
                    iconName: (rejectedStatus) ? rejectedStatus.icon : undefined,
                    style: {color: (rejectedStatus) ? rejectedStatus.color : undefined} 
                }
            }] : []),       
            ...(_.find(userProjectActions, a => a === 'ReadPending') ? [{
                key: 'downlaod',
                name: t('Download'),
                disabled: (loadingContent || loading || loadingScroll),
                iconProps: {
                    iconName: t('Download'),
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downlaodFiles',
                            name: t('Files'),
                            disabled: (total === 0 || selectedDocumentIds.length === 0 || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'fileName', contextItem: {fileName: codeWord + '_Documents_' + formatDateFile(new Date()), isParent: false}}) },
                            iconProps:  {
                                iconName: 'DownloadDocument'
                            } 
                        },
                        {
                            key: 'downloadComments',
                            name: t('Comments'),
                            disabled: (total === 0 || !commentsExist || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'comments', optional: codeWord + '_Comments_' + formatDateFile(new Date())}) },
                            iconProps: {
                                iconName: 'Comment',
                            },
                        }
                    ]
                }          
            }] : []),                         
            {
                key: 'excelReport',
                name: t('Report'),
                disabled: (total === 0 || loadingContent || loading || loadingScroll),
                onClick: () => { openGenericModal({id: 'excelReport', contextItem: {showAllversions: false}}) },
                iconProps: {
                    iconName: 'ExcelDocument',
                    style: {color: "#008000"}
                  },
            },
            {
                key: 'refresh',
                name: t('Refresh'),
                disabled: (loadingContent || loading || loadingScroll),
                onClick: () => { fetchDocuments({}) },
                iconProps: {
                    iconName: 'Refresh',
                },
            }   
        ]
        return buttons;
    };

    getFarButtons = () => {
      const {setFilterPanelOpened, filterPanelOpened, t} = this.props;
      return [
     
        {
          key: 'openPanel',
          name: t('Filters'),
          iconProps: {
            iconName: 'Filter'
          },
          ariaLabel: 'Filters',    
          onClick: () => {setFilterPanelOpened({open: !filterPanelOpened})}      
        },          
      ]; 
  };

    render() {
        const styles = getClassNames();
        return (
            <>
                <CommandBar
                    styles={{root: styles.root, secondarySet: {borderTop: 1}}}
                    items={this.getButtons()}
                    farItems={this.getFarButtons()}
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterPanelOpened: getFilterPanelOpened,
    documents: getContextualDocuments,
    total: getTotal,
    statusValues: getStatusValues,
    selectedProject: getSelectedProject,
    selectedDocument: getSelectedDocument,
    codeWord: getSelectedProjectCodeword
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setFilterPanelOpened: UiDocumentActions.setFilterPanelOpened,
        setOpenModal: DocumentCommandActions.setOpenModal,
        openGenericModal: ModalCommandActions.openModal,
        openEditModal: DocumentsCommandActions.openEditModal,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadFiles: DocumentsCommandActions.downloadFiles,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)((withTranslation()(DocumentsCommandBar)));
